import { FlexboxGrid } from 'rsuite';
import './auth-layout.scss';

export default function AuthLayout({ children })
{
    return (
        <div className='main-div show-grid'>
            <FlexboxGrid>
                {children}
            </FlexboxGrid>
        </div>
    );
}
